var AamsStrategyService_1;
import { __decorate } from "tslib";
import { Injectable } from "@angular/core";
import { AflaModuleStrategyService, SearchContainerHeight } from "./afla-module-strategy.service";
import _ from "underscore";
import { SaShortDatePipe } from "../../pipes/sa-short-date/sa-short-date.pipe";
import { ModuleConfig } from "../../models/module-config.model";
import { SharedConstants } from "../../constants/shared.constants";
import { ViewApplicationDetailsAamsComponent } from "../../../application/view-application/modules/a/view-application-details-aams/view-application-details-aams.component";
import { CreateApplicationDetailsAamsComponent } from "../../../application/create-application/modules/a/create-application-details-aams/create-application-details-aams.component";
import { SearchApplicantAgentComponent } from "../../../tabs/applications/application-search/search-applicant-agent/search-applicant-agent.component";
import { SearchAssignedToComponent } from "../../../tabs/applications/application-search/search-assigned-to/search-assigned-to.component";
import { ApplicationSearchService } from "../../../tabs/applications/shared/application-search.service";
import { catchError, distinctUntilChanged, map } from "rxjs/operators";
import { CRUDOperation } from "../../models/crud-operation-enum.model";
import { BehaviorSubject, throwError } from "rxjs";
import { AppControllerService } from "../../../app-controller.service";
import { HttpClient, HttpParams } from "@angular/common/http";
import { OdataQueryService } from "../odata-query/odata-query.service";
import { AppRoutingConstants } from "../../../app-routing.constants";
import { FormArray, FormControl, FormGroup, Validators } from "@angular/forms";
import { AlertType } from "../../models/alert";
import { CreateApplicationLocationAamsComponent } from "../../../application/create-application/modules/a/create-application-location-aams/create-application-location-aams.component";
import { ApplicationSearchConstants } from "../../../tabs/applications/application-search/application-search-constants";
import { ODataAction } from "../odata-query/odata-action.model";
import { RequestStatusService } from "../request-status/request-status.service";
import { SearchCreatedDateComponent } from "../../../tabs/applications/application-search/search-created-date/search-created-date.component";
import { SearchApplicantInfoComponent } from "../../../tabs/applications/application-search/search-applicant-info/search-applicant-info.component";
import { Router } from "@angular/router";
import { SearchStatusComponent } from "../../../tabs/applications/application-search/search-status/search-status.component";
import { RecipientSelectService } from "../../components/recipient-select/shared/service/recipient-select.service";
import { SearchApplicationTypeAamsComponent } from "../../../tabs/applications/application-search/modules/a/search-application-type-aams/search-application-type-aams.component";
import { SearchOwnerInfoComponent } from "../../../tabs/applications/application-search/search-owner-info/search-owner-info.component";
import { ViewApplicationLocationAamsComponent } from "../../../application/view-application/modules/a/view-application-location-aams/view-application-location-aams.component";
import { SearchOptionsConstants } from "../../../core/settings/components/search-options/search-options-constants";
import { ApiSearchOptionConstants } from "../../constants/api-constants/api-search-option.constants";
import { ApiApplicationSearchConstants } from "../../constants/api-constants/api-application-search.constants";
import RecipientUtils from "../../utils/recipient-utils";
import { ApiAdvertisingConstants } from "../../constants/api-constants/api-advertising.constants";
import { minLengthArray } from "../../classes/min-length-array-validator";
import { phoneNumberValidator } from "../../classes/phone-number-validator";
import { DatePipe } from "@angular/common";
import { WktConverterUtils } from "../../utils/wkt-converter-utils";
import { EsriDataTypeEnum } from "../../models/esri-data-type-enum";
import { SearchStartDateComponent } from "../../../tabs/applications/application-search/search-start-date/search-start-date.component";
import { SearchCategoryComponent } from "../../../tabs/applications/application-search/search-category/search-category.component";
import { AutoUnsub } from "../../decorators/autounsub.decorator";
import { BpamsBuildingUseSearchOptions } from "./bpams-strategy.service";
import { ApplicationsRoutingConstants } from "../../../tabs/applications/applications-routing.constants";
import { ModulePrefix } from "../../models/module-prefix.model";
// Not to be sorted!!!! ==> Already in correct sort order
// Please do not rename the enums ==> it will break the SearchOptions Field?Column Settings! Labels can be changed without any impact.
export var AamsSearchOptions;
(function (AamsSearchOptions) {
    AamsSearchOptions["ReferenceNumber"] = "Reference Number";
    AamsSearchOptions["MyApplications"] = "My Applications";
    AamsSearchOptions["ApplicantAgent"] = "Applicant Agent";
    AamsSearchOptions["ApplicantInfo"] = "Applicant Information";
    AamsSearchOptions["AppID"] = "Application ID";
    AamsSearchOptions["ApplicationStatus"] = "Application Status";
    AamsSearchOptions["ApplicationCategory"] = "Application Category";
    AamsSearchOptions["ApplicationTypes"] = "Application Types";
    AamsSearchOptions["ApplicationsWithoutStartDate"] = "Applications Without Start Date";
    AamsSearchOptions["AssignedToUsers"] = "Assigned to";
    AamsSearchOptions["UnassignedApplications"] = "Unassigned Applications";
    AamsSearchOptions["CreatedDate"] = "Created Date";
    AamsSearchOptions["CreatedDateRange"] = "Created Date Range";
    AamsSearchOptions["StartDate"] = "Started Date";
    AamsSearchOptions["StartDateRange"] = "Started Date Range";
    AamsSearchOptions["DaysUntilExpired"] = "Days until Expired";
    AamsSearchOptions["OwnerInfo"] = "Owner Information";
    AamsSearchOptions["PercentageComplete"] = "Percentage Complete";
    AamsSearchOptions["TimeoutStatus"] = "Timeout Status";
    AamsSearchOptions["JobID"] = "Job ID";
})(AamsSearchOptions || (AamsSearchOptions = {}));
// TODO these columns will change depending on how columns have been configured. This is the default list
export var ApplicationHeadingEnum;
(function (ApplicationHeadingEnum) {
    ApplicationHeadingEnum["ReferenceNumber"] = "Reference Number";
    ApplicationHeadingEnum["Applicant"] = "Applicant";
    ApplicationHeadingEnum["Agent"] = "Agent";
    ApplicationHeadingEnum["ErfNumber"] = "Erf Number";
    ApplicationHeadingEnum["ApplicationType"] = "Application Type";
    ApplicationHeadingEnum["StartDate"] = "Start Date";
    ApplicationHeadingEnum["ApplicationStatus"] = "Application Status";
    ApplicationHeadingEnum["DaysLeft"] = "Days left";
    ApplicationHeadingEnum["LastEditedBy"] = "Last Edited By";
    ApplicationHeadingEnum["LastEditedOn"] = "Last Edited On";
})(ApplicationHeadingEnum || (ApplicationHeadingEnum = {}));
export const applicationHeadingLookup = new Map([
    [ApplicationHeadingEnum.ReferenceNumber, "referenceNumber"],
    [ApplicationHeadingEnum.Applicant, "applicant"],
    [ApplicationHeadingEnum.Agent, "agent"],
    [ApplicationHeadingEnum.ApplicationType, "type"],
    [ApplicationHeadingEnum.StartDate, "startDate"],
    [ApplicationHeadingEnum.ApplicationStatus, "phase"],
    [ApplicationHeadingEnum.DaysLeft, "daysLeft"],
    [ApplicationHeadingEnum.LastEditedBy, "lastEditedBy"],
    [ApplicationHeadingEnum.LastEditedOn, "lastEditedOn"],
]);
export var ApplicationSummaryColumnsEnum;
(function (ApplicationSummaryColumnsEnum) {
    ApplicationSummaryColumnsEnum["ReferenceNumber"] = "Reference Number";
    ApplicationSummaryColumnsEnum["Applicant"] = "Applicant";
    ApplicationSummaryColumnsEnum["Agent"] = "Agent";
    ApplicationSummaryColumnsEnum["ErfNumber"] = "Erf Number";
    ApplicationSummaryColumnsEnum["ApplicationType"] = "Application Type";
    ApplicationSummaryColumnsEnum["StartDate"] = "Start Date";
    ApplicationSummaryColumnsEnum["Phase"] = "Application status";
    ApplicationSummaryColumnsEnum["DaysLeft"] = "Days left";
    ApplicationSummaryColumnsEnum["LastEditedBy"] = "Last Edited By";
    ApplicationSummaryColumnsEnum["LastEditedOn"] = "Last Edited On";
})(ApplicationSummaryColumnsEnum || (ApplicationSummaryColumnsEnum = {}));
export const applicationSummaryColumnsLookup = new Map([
    [ApplicationSummaryColumnsEnum.ReferenceNumber, "referenceNumber"],
    [ApplicationSummaryColumnsEnum.Applicant, "applicant"],
    [ApplicationSummaryColumnsEnum.Agent, "agent"],
    [ApplicationSummaryColumnsEnum.ApplicationType, "type"],
    [ApplicationSummaryColumnsEnum.StartDate, "startDate"],
    [ApplicationSummaryColumnsEnum.Phase, "phase"],
    [ApplicationSummaryColumnsEnum.DaysLeft, "daysLeft"],
    [ApplicationSummaryColumnsEnum.LastEditedBy, "lastEditedBy"],
    [ApplicationSummaryColumnsEnum.LastEditedOn, "lastEditedOn"],
]);
export const AamsSearchQueryLookup = new Map([
    [AamsSearchOptions.AppID, "appId"],
    [AamsSearchOptions.ReferenceNumber, "referenceNumber"],
    [AamsSearchOptions.JobID, "jobId"]
]);
export const AamsAdditionalSearchOptions = [AamsSearchOptions.MyApplications,
    AamsSearchOptions.AssignedToUsers,
    AamsSearchOptions.UnassignedApplications,
    AamsSearchOptions.ApplicationsWithoutStartDate];
export const AamsDateSearchOptions = new Map([
    [AamsSearchOptions.CreatedDate, 1],
    [AamsSearchOptions.CreatedDateRange, 2],
]);
export const AamsStartRangeRangeSearchOptions = new Map([
    [AamsSearchOptions.StartDate, 1],
    [AamsSearchOptions.StartDateRange, 2],
]);
export const AamsStatusSearchOptions = new Map([
    [AamsSearchOptions.ApplicationStatus, ApplicationSearchConstants.STATUS],
    [AamsSearchOptions.PercentageComplete, ApplicationSearchConstants.PERCENT_COMPLETE],
    [AamsSearchOptions.DaysUntilExpired, ApplicationSearchConstants.DAYS_UNTIL_EXPIRED],
    [AamsSearchOptions.TimeoutStatus, ApplicationSearchConstants.TIMEOUT_STATUS],
]);
export const AamsSearchOptionClientHeight = new Map([
    [AamsSearchOptions.ReferenceNumber, SearchContainerHeight.Simple],
    [AamsSearchOptions.MyApplications, SearchContainerHeight.Simple],
    [AamsSearchOptions.AppID, SearchContainerHeight.Simple],
    [AamsSearchOptions.UnassignedApplications, SearchContainerHeight.Simple],
    [AamsSearchOptions.ApplicationStatus, SearchContainerHeight.SingleLine],
    [AamsSearchOptions.ApplicationTypes, SearchContainerHeight.SingleLine],
    [AamsSearchOptions.PercentageComplete, SearchContainerHeight.SingleLine],
    [AamsSearchOptions.DaysUntilExpired, SearchContainerHeight.SingleLine],
    [AamsSearchOptions.TimeoutStatus, SearchContainerHeight.SingleLine],
    [AamsSearchOptions.CreatedDate, SearchContainerHeight.SingleLine],
    [AamsSearchOptions.AssignedToUsers, SearchContainerHeight.SingleLine],
    [AamsSearchOptions.CreatedDateRange, SearchContainerHeight.SingleLine],
    [AamsSearchOptions.ApplicantAgent, SearchContainerHeight.Extended],
    [AamsSearchOptions.ApplicantInfo, SearchContainerHeight.Extended],
    [AamsSearchOptions.OwnerInfo, SearchContainerHeight.Extended],
]);
// IMPORTANT: these values much match the DB table names and the Property names used by oData entity for Module
export var AamsSearchOptionTableListEnum;
(function (AamsSearchOptionTableListEnum) {
    AamsSearchOptionTableListEnum["Application"] = "A_APPLICATION|Application";
    AamsSearchOptionTableListEnum["Property"] = "A_APPLICATIONPOLYGON|Properties";
    AamsSearchOptionTableListEnum["Owner"] = "AFLA_Recipient|Owners";
    AamsSearchOptionTableListEnum["Status"] = "AFLA_APPLICATIONSTATUS|Status";
    AamsSearchOptionTableListEnum["ApplicationType"] = "A_APPLICATION|Type";
    AamsSearchOptionTableListEnum["Applicant"] = "AFLA_Recipient|Applicant";
    AamsSearchOptionTableListEnum["ApplicantAgent"] = "AFLA_Recipient|ApplicantAgent";
})(AamsSearchOptionTableListEnum || (AamsSearchOptionTableListEnum = {}));
export const AExpandListForApplicationSearch = ApplicationSearchConstants.APP_SEARCH_EXPAND_FULL_LIST_A;
export const ATableNameListForSearchOptions = AamsSearchOptionTableListEnum.Application
    + "," + AamsSearchOptionTableListEnum.Property
    + "," + AamsSearchOptionTableListEnum.Owner
    + "," + AamsSearchOptionTableListEnum.Status
    + "," + AamsSearchOptionTableListEnum.ApplicationType
    + "," + AamsSearchOptionTableListEnum.Applicant
    + "," + AamsSearchOptionTableListEnum.ApplicantAgent;
export var CreateApplicationMenuHeadings;
(function (CreateApplicationMenuHeadings) {
    CreateApplicationMenuHeadings["Details"] = "Details";
    CreateApplicationMenuHeadings["ApplicantAgent"] = "Applicant / agent";
    CreateApplicationMenuHeadings["Location"] = "Location";
    CreateApplicationMenuHeadings["Notes"] = "Notes";
})(CreateApplicationMenuHeadings || (CreateApplicationMenuHeadings = {}));
export var ViewApplicationMenuHeadings;
(function (ViewApplicationMenuHeadings) {
    ViewApplicationMenuHeadings["Details"] = "Details";
    ViewApplicationMenuHeadings["Applicant"] = "Applicant / applicant agent";
    ViewApplicationMenuHeadings["Location"] = "Location";
    ViewApplicationMenuHeadings["Assessment"] = "Assessment";
    ViewApplicationMenuHeadings["Attachments"] = "Attachments";
    ViewApplicationMenuHeadings["Checklist"] = "Checklist";
    ViewApplicationMenuHeadings["Comments"] = "Comments";
    ViewApplicationMenuHeadings["Communication"] = "Communication";
    ViewApplicationMenuHeadings["Conditions"] = "Conditions";
    ViewApplicationMenuHeadings["History"] = "History";
    ViewApplicationMenuHeadings["Invoices"] = "Invoices";
    ViewApplicationMenuHeadings["Notes"] = "Notes";
    ViewApplicationMenuHeadings["RelatedApplicationSearch"] = "Related applications";
    ViewApplicationMenuHeadings["RequiredDocumentsChecklist"] = "Required documents checklist";
    ViewApplicationMenuHeadings["Result"] = "Result";
    ViewApplicationMenuHeadings["ScheduledReminders"] = "Scheduled Reminders";
    ViewApplicationMenuHeadings["Status"] = "Status";
    ViewApplicationMenuHeadings["StepManagement"] = "Step management";
    ViewApplicationMenuHeadings["Survey123"] = "Survey123";
    ViewApplicationMenuHeadings["Timeouts"] = "Timeouts";
    ViewApplicationMenuHeadings["Team"] = "Team";
})(ViewApplicationMenuHeadings || (ViewApplicationMenuHeadings = {}));
export var SettingsMenuHeadings;
(function (SettingsMenuHeadings) {
    SettingsMenuHeadings["AvailableSurvey123s"] = "Available survey123s";
    SettingsMenuHeadings["Lookups"] = "Lookups";
    SettingsMenuHeadings["MapConfig"] = "Map services";
    SettingsMenuHeadings["NonWorkingDays"] = "Non-working days";
    SettingsMenuHeadings["AttachmentTypes"] = "Attachment types";
    SettingsMenuHeadings["Recipients"] = "Recipients";
    SettingsMenuHeadings["RecipientGroups"] = "Recipient groups";
    SettingsMenuHeadings["Reports"] = "Reports";
    SettingsMenuHeadings["StepMetaData"] = "Step metadata";
    SettingsMenuHeadings["Tariffs"] = "Tariffs";
    SettingsMenuHeadings["Templates"] = "Templates";
    SettingsMenuHeadings["NotificationTemplates"] = "Notification templates";
    SettingsMenuHeadings["ModuleRoles"] = "Module roles";
    SettingsMenuHeadings["AFLAPortalDocuments"] = "Afla portal documents";
    SettingsMenuHeadings["AFLAPortalUpdateOwners"] = "Afla portal update owners";
    SettingsMenuHeadings["SearchOptions"] = "Search options";
    SettingsMenuHeadings["SearchSettings"] = "Search settings";
    SettingsMenuHeadings["BackupRestore"] = "Backup and restore";
    SettingsMenuHeadings["ArcGISItems"] = "ArcGIS items";
    SettingsMenuHeadings["AFLAPortalMessagesAndPages"] = "AFLA portal messages and pages";
    SettingsMenuHeadings["InvoiceTemplates"] = "Invoice templates";
    SettingsMenuHeadings["Stamps"] = "Stamps";
    SettingsMenuHeadings["ApplicationWorkflowUpgrade"] = "Application workflow upgrade";
})(SettingsMenuHeadings || (SettingsMenuHeadings = {}));
export const ARequiredMapFields = [{
        mapName: "Property",
        fields: [
            { name: "ErfSize", type: EsriDataTypeEnum.integer },
        ]
    }];
let AamsStrategyService = class AamsStrategyService extends AflaModuleStrategyService {
    static { AamsStrategyService_1 = this; }
    saShortDatePipe;
    applicationSearchService;
    appControllerService;
    oDataQueryService;
    datePipe;
    requestStatusService;
    http;
    appController;
    router;
    recipientSelectService;
    overdueApplicationExpandFields = "status, applicant";
    showApplicantAgentForModule = false;
    requiredMapFields;
    createApplicationMenuHeadings;
    overrideMapDefault = {};
    viewApplicationComponentLookup;
    name = ModuleConfig.Advertising;
    modulePrefix = ModulePrefix.Advertising;
    searchQueryLookup;
    defaultSearchColumns;
    searchOptions;
    applicationEndpoint;
    extendedSimpleSearchOptions;
    dateSearchOptions;
    RangeSearchOptions;
    statusSearchOptions;
    buildingUseSearchOptions;
    groupSearchOptions;
    clientHeightMap;
    createApplicationComponentLookup;
    advancedSearchComponentLookup;
    viewApplicationMenuHeadings;
    applicationSummaryColumnsMap;
    // column headers are dynamic
    applicationTableColumnMap = new BehaviorSubject(null);
    applicationTableColumnMapObservable = this.applicationTableColumnMap.asObservable();
    applicationServiceUrl = ApiAdvertisingConstants.URL;
    form;
    lookups = new Map();
    userId;
    moduleUsers;
    expandListForApplicationSearch = AExpandListForApplicationSearch;
    expandListForApplicationSearchFullList = AExpandListForApplicationSearch;
    searchOptionTableNameList = ATableNameListForSearchOptions;
    customApplicationTableColumnMap = null;
    selectedSearchOptionLookup;
    searchOptionsWithCustomColumns = [];
    searchOptionsFieldList;
    searchOptionsMap;
    isPrevSavedSearch = false;
    aflaPortalConfigurableMessages = [
        "Welcome help",
        "Welcome page",
        "Application help",
        "Property help",
        "Applicant help",
        "Agent help",
        "Required documentation help",
        "Notes help",
        "Summary help",
        "Create application status page",
        "View application status page",
        "Communication help"
    ];
    setApplicantAndApplicantAgentAction = ApiAdvertisingConstants.FUNCTION_SET_APPLICANT_AND_APPLICANT_AGENT;
    settingsMenuHeadings;
    settingsComponentLookup;
    propertiesPageHeading = "advertisements";
    statusColumn = "status/ workflowSection";
    moduleRequiredMaps;
    stampOptions = [];
    previousApplication = null;
    createApplicationSubscription;
    constructor(saShortDatePipe, applicationSearchService, appControllerService, oDataQueryService, datePipe, requestStatusService, http, appController, router, recipientSelectService) {
        super();
        this.saShortDatePipe = saShortDatePipe;
        this.applicationSearchService = applicationSearchService;
        this.appControllerService = appControllerService;
        this.oDataQueryService = oDataQueryService;
        this.datePipe = datePipe;
        this.requestStatusService = requestStatusService;
        this.http = http;
        this.appController = appController;
        this.router = router;
        this.recipientSelectService = recipientSelectService;
        this.initForm();
        this.applicationEndpoint = ApiApplicationSearchConstants.ADVERTISING_ENDPOINT;
        this.createApplicationMenuHeadings = CreateApplicationMenuHeadings;
        this.viewApplicationMenuHeadings = ViewApplicationMenuHeadings;
        this.settingsMenuHeadings = SettingsMenuHeadings;
        this.moduleRequiredMaps = ["Property"];
        this.requiredMapFields = ARequiredMapFields;
        super.init();
    }
    static getRecipientFullName(firstName, surname) {
        if (!firstName && !surname) {
            return "";
        }
        if (!firstName) {
            return surname;
        }
        return `${firstName} ${surname}`;
    }
    static getRecipientName(recipient) {
        if (!recipient) {
            return "";
        }
        return this.getRecipientFullName(recipient.name, recipient.surname);
    }
    // the format for a column filter on an child table is:
    //    EQUALS ==> applicantAgent/any(m:m/name eq 'xxxx')
    //    CONTAINS with tolower ==> applicantAgent/any(b:contains(tolower(b/name),'xxxx'))
    static buildColumnFilter(text, filter) {
        const column = filter ? filter : ApplicationSearchConstants.DEFAULT_SEARCH;
        return `contains(tolower(cast(${column.trim()},'Edm.String')),'${text.trim().toLowerCase()}') and eLodgementComplete eq true`;
    }
    static buildExpand(params, top) {
        params = params.set(ODataAction.Expand, AExpandListForApplicationSearch);
        params = params.set(ODataAction.Top, top);
        params = params.set(ODataAction.OrderBy, "startDate ne null desc, startDate desc, appId desc");
        return params;
    }
    static getFirstRecipient(recipients) {
        if (recipients && recipients.length > 0) {
            return recipients[0];
        }
    }
    buildListFilter(list, column) {
        const params = AamsStrategyService_1.buildExpand(new HttpParams(), this.appControllerService.fetchRecordCountValue);
        return this.oDataQueryService.buildFilterFromArray(params, column, list);
    }
    getStatusForModule(moduleID, statusField) {
        return this.applicationSearchService.getStatusForModule(moduleID, statusField);
    }
    getUsersForModule(moduleID) {
        return this.applicationSearchService.getUsersForModule(moduleID);
    }
    getApplicationTypesForModule(moduleID) {
        return this.applicationSearchService.getApplicationTypesForModule(moduleID);
    }
    initializeSearchQueryLookup() {
        this.searchQueryLookup = AamsSearchQueryLookup;
    }
    initializeAdditionalSearchLookup() {
        this.extendedSimpleSearchOptions = AamsAdditionalSearchOptions;
    }
    initializeApplicationSummaryColumnsMap() {
        this.applicationSummaryColumnsMap = applicationSummaryColumnsLookup;
    }
    initializeSearchOptionsLookup() {
        this.searchOptions = new Array();
        this.searchOptions.push(..._.values(AamsSearchOptions));
        // this is used for the SearchOptions settings
        this.searchOptionsMap = new Map();
        for (const [key, value] of Object.entries(AamsSearchOptions)) {
            this.searchOptionsMap.set(key, value);
        }
        // default column list if search option types does not have a default
        this.defaultSearchColumns = applicationHeadingLookup;
    }
    initializeDateSearchOptions() {
        this.dateSearchOptions = AamsDateSearchOptions;
        this.RangeSearchOptions = AamsStartRangeRangeSearchOptions;
    }
    initializeStatusSearchOptions() {
        this.statusSearchOptions = AamsStatusSearchOptions;
        this.clientHeightMap = AamsSearchOptionClientHeight;
    }
    initializeGroupSearchOptions = () => {
    };
    getFieldListForSearchOptions(moduleId) {
        const params = {
            $filter: AamsStrategyService_1.buildModuleIDFilter(moduleId),
            $expand: SearchOptionsConstants.SEARCH_OPTIONS_EXPAND,
            $orderby: SearchOptionsConstants.SEARCH_OPTIONS_COLUMNS_ORDERBY
        };
        const url = `${ApiSearchOptionConstants.URL}`;
        return this.http.get(url, { params }).pipe(map((response) => {
            this.searchOptionsWithCustomColumns = [];
            this.searchOptionsFieldList = response.value;
            this.searchOptionsFieldList.forEach((option) => {
                const searchOptionLookup = this.getSearchOptionLookup(option.searchOption);
                // @ts-ignore
                if (this.searchOptionsWithCustomColumns.indexOf(searchOptionLookup) < 0) { // @ts-ignore
                    this.searchOptionsWithCustomColumns.push(searchOptionLookup);
                }
            });
            return response.value;
        }));
    }
    defaultSearchModel(application) {
        return {
            id: application.id,
            appId: application.appId,
            jobId: application.jobId,
            referenceNumber: application.referenceNumber,
            applicant: AamsStrategyService_1.getRecipientName(AamsStrategyService_1.getFirstRecipient(application.applicant)),
            agent: AamsStrategyService_1.getRecipientName(AamsStrategyService_1.getFirstRecipient(application.applicantAgent)),
            type: application.type,
            startDate: application.createdDate !== null
                ? this.saShortDatePipe.transform(application.startDate)
                : "",
            // TODO: we have relabelled all instances of "Phase" to "Application status"
            //  - do we need to do the same for the property name "phase" => "applicationStatus" for consistency?
            //  - don't forget to apply to all module services!!
            phase: application.status?.workflowSection,
            daysLeft: application.status?.daysUntilExpired,
            lastEditedBy: this.getLastEditedByUser(application.lastEditedUser),
            lastEditedOn: application.lastEditedDate !== null
                ? this.saShortDatePipe.transform(application.lastEditedDate)
                : "",
            moduleId: application.moduleId,
        };
    }
    getLastEditedByUser(lastEditedUser) {
        return lastEditedUser ? `${lastEditedUser.lastName}, ${lastEditedUser.firstName}` : "";
    }
    getApplicationFieldValue(application, appGroup, fieldName) {
        let fieldValue;
        for (const [key, value] of Object.entries(application)) {
            if (!fieldValue && appGroup.toLowerCase() === "application") {
                if (key.toLowerCase() === fieldName.toLowerCase()) {
                    fieldValue = value;
                    break;
                }
            }
            else {
                if (!fieldValue
                    && key.toLowerCase() === appGroup.toLowerCase()) {
                    // some applications may have null lower order properties e.g. Status
                    if (value) {
                        const group = value[0] ? value[0] : value;
                        for (const [groupKey, groupValue] of Object.entries(group)) {
                            switch (appGroup.toLowerCase()) {
                                case "applicant":
                                case "applicantagent":
                                    if (groupKey.toLowerCase() === fieldName.toLowerCase()) {
                                        fieldValue = groupValue;
                                        break;
                                    }
                                    break;
                                case "status":
                                    if (groupKey.toLowerCase() === fieldName.toLowerCase()) {
                                        switch (fieldName.toLowerCase()) {
                                            case "assignedto":
                                            case "createdby":
                                                // these fields will be handled in the user section below
                                                break;
                                            default:
                                                fieldValue = groupValue;
                                                break;
                                        }
                                        break;
                                    }
                                    break;
                                // the following properties can be multiple values - we cannot use ObjectUtils.getCommaSeparatedValuesFromListForKey because it is case sensitive
                                case "advertisements":
                                    if (groupKey.toLowerCase() === fieldName.toLowerCase()) {
                                        fieldValue = fieldValue ? fieldValue += ", " + groupValue : groupValue;
                                    }
                                    break;
                            }
                        }
                    }
                }
                if (fieldValue)
                    break;
            }
        }
        if (!fieldValue)
            fieldValue = "";
        if (fieldName.toLowerCase().endsWith("date") || fieldName.toLowerCase().startsWith("date")) {
            fieldValue = fieldValue ? this.saShortDatePipe.transform(fieldValue) : "";
        }
        else {
            switch (fieldName.toLowerCase()) {
                case "lasteditedby":
                    fieldValue = this.getUserName(application.lastEditedUser);
                    break;
                case "createdby":
                    fieldValue = application.status ? this.getUserNameFromId(application.status.createdBy) : "";
                    break;
                case "assignedto":
                    fieldValue = application.status ? this.getUserNameFromId(application.status.assignedTo) : "";
                    break;
                case "createduserid":
                    fieldValue = this.getUserName(application.createdSystemUser);
                    break;
            }
        }
        return fieldValue;
    }
    customColumnSearchModel(application, columnList, isPrevSavedSearch = false) {
        // need to reset the column map if the search options customised columns have been updated
        // need to reset the column map if the search options customised columns have been updated
        if ((this.customApplicationTableColumnMap.size !== 0 && columnList.length !== this.customApplicationTableColumnMap.size)
            || isPrevSavedSearch) {
            this.customApplicationTableColumnMap.clear();
            this.isPrevSavedSearch = false;
        }
        let resetHeadings = this.customApplicationTableColumnMap.size === 0;
        const appDetails = {};
        if (columnList.length > 0) {
            columnList.forEach((column) => {
                const fieldAlias = column.moduleField.fieldAlias;
                const fieldName = column.moduleField.fieldName;
                const tableLookup = this.getSearchOptionLookup(`${column.moduleField.tableAlias}`);
                const appGroup = this.getApplicationTableProperty(`${column.moduleField.tableName}|${tableLookup}`);
                const appProperty = `${appGroup.toLowerCase()}${fieldName.toLowerCase()}`;
                appDetails[appProperty] = this.getApplicationFieldValue(application, tableLookup, fieldName);
                if (resetHeadings)
                    this.customApplicationTableColumnMap.set(fieldAlias, appProperty);
            });
            // standard fields to add in case the user did not add them
            // @ts-ignore
            appDetails.id = application.id;
            // @ts-ignore
            appDetails.moduleId = application.moduleId;
            // @ts-ignore
            appDetails.jobId = application.jobId;
            // @ts-ignore
            appDetails.appId = application.appId;
            // only set the headings once for the search
            if (resetHeadings) {
                this.changeAppTableColumnMap(this.customApplicationTableColumnMap);
                resetHeadings = false;
            }
            return appDetails;
        }
        else
            return this.defaultSearchModel(application);
    }
    getApplicationTableProperty(tableName) {
        let property = "";
        for (const [tableKey, tableValue] of Object.entries(AamsSearchOptionTableListEnum)) {
            if (tableValue.toLowerCase() === tableName.toLowerCase()) {
                // @ts-ignore
                property = tableKey;
                break;
            }
        }
        return property;
    }
    getUserNameFromId(userId) {
        let userName = "";
        if (userId) {
            this.applicationSearchService.moduleUsers.forEach((user) => {
                if (Number(user.id) === userId)
                    userName = `${user.lastName}, ${user.firstName}`;
            });
        }
        return userName;
    }
    getUserName(user) {
        return user ? `${user.lastName}, ${user.firstName}` : "";
    }
    getCustomApplicationSearchModel(searchOptionLookup) {
        // identify columnList for specific search option
        return this.applicationSearchService.getSearchOptionColumnList(this, searchOptionLookup);
    }
    mapFromApplicationEntityToApplicationSearchModel(application) {
        if (application) {
            return this.defaultSearchModel(application);
        }
    }
    initializeSettingsComponents() {
        this.settingsComponentLookup = new Map([]);
    }
    initializeViewApplicationComponents() {
        this.viewApplicationComponentLookup = new Map([
            [
                ViewApplicationMenuHeadings.Details,
                ViewApplicationDetailsAamsComponent,
            ],
            [
                ViewApplicationMenuHeadings.Location,
                ViewApplicationLocationAamsComponent,
            ],
        ]);
    }
    initializeCreateApplicationComponents() {
        this.createApplicationComponentLookup = new Map([
            [
                CreateApplicationMenuHeadings.Details,
                CreateApplicationDetailsAamsComponent,
            ],
            [
                CreateApplicationMenuHeadings.Location,
                CreateApplicationLocationAamsComponent,
            ],
        ]);
    }
    initializeAdvancedApplicationSearchComponents() {
        this.advancedSearchComponentLookup = new Map([
            [AamsSearchOptions.ApplicantAgent, SearchApplicantAgentComponent],
            [AamsSearchOptions.AssignedToUsers, SearchAssignedToComponent],
            [AamsSearchOptions.CreatedDate, SearchCreatedDateComponent],
            [AamsSearchOptions.CreatedDateRange, SearchCreatedDateComponent],
            [AamsSearchOptions.StartDate, SearchStartDateComponent],
            [AamsSearchOptions.StartDateRange, SearchStartDateComponent],
            [AamsSearchOptions.ApplicantInfo, SearchApplicantInfoComponent],
            [AamsSearchOptions.PercentageComplete, SearchStatusComponent],
            [AamsSearchOptions.ApplicationStatus, SearchStatusComponent],
            [AamsSearchOptions.ApplicationCategory, SearchCategoryComponent],
            [AamsSearchOptions.TimeoutStatus, SearchStatusComponent],
            [AamsSearchOptions.DaysUntilExpired, SearchStatusComponent],
            [AamsSearchOptions.ApplicationTypes, SearchApplicationTypeAamsComponent],
            [AamsSearchOptions.OwnerInfo, SearchOwnerInfoComponent],
        ]);
    }
    getSearchOptionLookup(selectedSearchOption) {
        const keys = [...this.searchOptionsMap.entries()]
            .filter(({ 1: v }) => v === selectedSearchOption)
            .map(([k]) => k);
        return keys.length > 0 ? keys[0].toString() : selectedSearchOption;
    }
    initializeApplicationTableColumnMap() {
        this.changeAppTableColumnMap(this.customApplicationTableColumnMap
            ? this.customApplicationTableColumnMap : applicationHeadingLookup);
    }
    changeAppTableColumnMap(tableColumnMap) {
        this.applicationTableColumnMap.next(tableColumnMap);
    }
    doSearchApplicationsByUser(userId, moduleID, pageHeading) {
        // @ts-ignore
        return this.applicationSearchService
            .searchByUser(userId, moduleID, this)
            .pipe(distinctUntilChanged(), map((applications) => this.applicationSearchService.sortApplicationList(applications, "startDate", false, "appId")), catchError((error) => {
            this.appControllerService.handleServerErrorMessage(pageHeading, error, CRUDOperation.Get);
            return throwError(error);
        }));
    }
    doSearchApplicationsByResponsiblePerson(userId, moduleID, pageHeading) {
        // @ts-ignore
        return this.applicationSearchService
            .searchByUser(userId, moduleID, this)
            .pipe(distinctUntilChanged(), map((applications) => this.applicationSearchService.sortApplicationList(applications, "startDate", false, "appId")), catchError((error) => {
            this.appControllerService.handleServerErrorMessage(pageHeading, error, CRUDOperation.Get);
            return throwError(error);
        }));
    }
    doSearchUnassignedApplications(moduleID, pageHeading) {
        // @ts-ignore
        return this.applicationSearchService
            .searchByUnassignedApplication(moduleID, this)
            .pipe(distinctUntilChanged(), map((applications) => this.applicationSearchService.sortApplicationList(applications, "startDate", false, "appId")), catchError((error) => {
            this.appControllerService.handleServerErrorMessage(pageHeading, error, CRUDOperation.Get);
            return throwError(error);
        }));
    }
    doApplicationSearch(search, moduleID, pageHeading, withDefaultColumns) {
        const column = this.getEntityColumn(search.column);
        // @ts-ignore
        return this.applicationSearchService
            .searchApplicationsUsingSimpleSearch(search.text, column, this, moduleID, withDefaultColumns)
            .pipe(distinctUntilChanged(), map((applications) => this.applicationSearchService.sortApplicationList(applications, "startDate", false, "appId")), catchError((error) => {
            this.appControllerService.handleServerErrorMessage(pageHeading, error, CRUDOperation.Get);
            return throwError(error);
        }));
    }
    doSearchApplicationsWithoutStartDate(moduleID, pageHeading) {
        // @ts-ignore
        return this.applicationSearchService
            .searchApplicationsWithoutStartDate(moduleID, this)
            .pipe(distinctUntilChanged(), map((applications) => // Add explicit typing here
         this.applicationSearchService.sortApplicationList(applications, "appId", true, "appId")), catchError((error) => {
            this.appControllerService.handleServerErrorMessage(pageHeading, error, CRUDOperation.Get);
            return throwError(error);
        }));
    }
    getApplicationsQuery(params) {
        return this.http.get(AppRoutingConstants.createEndpointRoutev2(this.applicationEndpoint), { params });
    }
    getApplicationsQueryExtended(params, extendedEndPoint) {
        return this.http.get(AppRoutingConstants.createEndpointRoutev2(this.applicationEndpoint, extendedEndPoint), { params });
    }
    getApplicationsSearchRequestWithAdditionalFilters(text, filter, moduleID) {
        let params = AamsStrategyService_1.buildExpand(new HttpParams(), this.appControllerService.fetchRecordCountValue);
        params = this.oDataQueryService.filter(params, AflaModuleStrategyService.buildModuleIDFilter(moduleID), AamsStrategyService_1.buildColumnFilter(text, filter));
        return this.getApplicationsQuery(params);
    }
    buildApplicationSearchBaseRequest(moduleID) {
        let params = AamsStrategyService_1.buildExpand(new HttpParams(), this.appControllerService.fetchRecordCountValue);
        params = this.oDataQueryService.filter(params, AamsStrategyService_1.buildModuleIDFilter(moduleID), AamsStrategyService_1.showCompleteApplications());
        return this.getApplicationsQuery(params);
    }
    buildDashboardApplicationsSearch(moduleID, dashboardFilter) {
        let params = AamsStrategyService_1.buildExpand(new HttpParams(), this.appControllerService.fetchRecordCountValue);
        params = this.applicationSearchService.dashboardSearch(params, dashboardFilter, moduleID);
        return this.getApplicationsQuery(params);
    }
    createApplication() {
        this.requestStatusService.showBusySpinner("CreateAamsApplication");
        const application = this.buildApplication();
        this.createApplicationSubscription =
            this.postApplicationService(application)
                .subscribe({
                next: (savedApplication) => {
                    this.appController.showMessage(AamsStrategyService_1.successMessage(savedApplication.jobId), AlertType.Success);
                    this.resetForm();
                    this.requestStatusService.removeBusySpinner("CreateAamsApplication");
                    this.router.navigate([
                        AppRoutingConstants.ROUTE_SEPERATOR + ApplicationsRoutingConstants.REFRESH_ROUTE,
                        {
                            jobId: savedApplication.jobId,
                            moduleId: this.appController.selectedModuleID,
                            type: ApplicationsRoutingConstants.REFRESH_VIEW_APPLICATION_ROUTE
                        }
                    ]);
                },
                error: (error) => {
                    this.requestStatusService.removeBusySpinner("CreateAamsApplication");
                    this.appController.handleServerErrorMessage("application", error, CRUDOperation.Add);
                }
            });
    }
    getApplicationGeometries(jobID, moduleID) {
        const params = {
            $select: "point, polygon, shape",
            $expand: "point, polygon",
            $filter: `jobId eq ${+jobID} and moduleId eq ${+moduleID}`
        };
        return this.http.get(AppRoutingConstants.createEndpointRoutev2(this.applicationEndpoint), { params });
    }
    resetForm() {
        this.form.reset();
        this.form.get("advertisementsForm").get("advertisements").clear();
        this.form.get("noteForm").get("notes").clear();
    }
    postApplicationService(params) {
        return this.http.post(ApiAdvertisingConstants.URL, params);
    }
    getSelectedApplicationSummaryExpand() {
        return "status, applicant, applicant($expand=groups), applicantAgent, lastEditedUser";
    }
    getSearchUrlForModule(selectedSearchOption) {
        switch (selectedSearchOption) {
            case ApiApplicationSearchConstants.FUNCTION_GET_APPLICATIONS_BY_USER:
                return ApiApplicationSearchConstants.FUNCTION_GET_A_APPLICATIONS_BY_USER;
            case ApiApplicationSearchConstants.FUNCTION_GET_APPLICATIONS_CREATED_BY_USER:
                return ApiApplicationSearchConstants.FUNCTION_GET_A_APPLICATIONS_CREATED_BY_USER;
        }
    }
    getSearchResponsiblePersonUrlForModule(selectedSearchOption) {
        switch (selectedSearchOption) {
            case ApiApplicationSearchConstants.FUNCTION_GET_APPLICATIONS_BY_RESPONSIBLEPERSON:
                return ApiApplicationSearchConstants.FUNCTION_GET_A_APPLICATIONS_BY_RESPONSIBLEPERSON;
        }
    }
    generateInvoiceReportService(applicationId, invoiceID, canDownloadInPortal = false) {
        const params = {
            invoiceId: invoiceID,
            canDownloadInPortal
        };
        return this.http.get(`${ApiAdvertisingConstants.URL}/${applicationId}/${ApiAdvertisingConstants.FUNCTION_GET_GENERATE_INVOICE}`, { responseType: "blob", params });
    }
    getRequiredDocumentsChecklist(applicationId, jobId) {
        const params = {
            $filter: jobId
        };
        return this.http.get(`${ApiAdvertisingConstants.URL}/${applicationId}/${ApiAdvertisingConstants.FUNCTION_GET_GENERATE_REQUIRED_DOCUMENTS_CHECKLIST}`, { params })
            .pipe(map((data) => {
            return data.value;
        }));
    }
    getExternalLinks(moduleId, jobId, category) {
        var params = {
            jobId: jobId,
            category: category
        };
        return this.http.get(`${ApiAdvertisingConstants.URL}/${moduleId}/${ApiAdvertisingConstants.FUNCTION_GET_EXTERNAL_LINKS}`, { params })
            .pipe(map((data) => {
            return data.value;
        }));
    }
    initForm() {
        this.form = new FormGroup({
            applicantForm: new FormGroup({
                applicantRecipient: new FormControl(null, [Validators.required]),
                applicantAgentRecipient: new FormControl(null),
                copyApplicantDetails: new FormControl(null),
                markApplicantAgentAsNotApplicable: new FormControl(null)
            }),
            noteForm: new FormGroup({
                newNote: new FormControl(null),
                notes: new FormArray([]),
            }),
            detailsForm: new FormGroup({
                description: new FormControl(null, [Validators.required]),
                isAdvetisingPermanentOrTemporary: new FormControl(null, Validators.required), // Is the advertising permanent or temporary?
                permanentApplicationDuration: new FormControl(null), // will the permanent advertising be there for 1 year or 5 years?
                type: new FormControl(null, [Validators.required]), // Application type
                displayStartDate: new FormControl(null), // temporary application types
                displayEndDate: new FormControl(null), // temporary application types
                displayRemovalDate: new FormControl(null), // temporary application types
                numberOfPosters: new FormControl(0), // temporary application types
                applicationDuration: new FormControl(null), // permanent application types
                nameOfBusiness: new FormControl(null), // permanent application types
                notifySignageRemovalPeriod: new FormControl(null), // permanent application types
                positionOfDisplay: new FormControl(null), // permanent application types
                dimensionsH: new FormControl(0), // permanent application types
                dimensionsW: new FormControl(0), // permanent application types
                dimensionsD: new FormControl(0), // permanent application types
                material: new FormControl(null), // permanent application types
                colours: new FormControl(null), // permanent application types
                frontalArea: new FormControl(0), // permanent application types
                totalArea: new FormControl(0), // permanent application types
                signType: new FormControl(null), // permanent application types
                weight: new FormControl(0), // permanent application types
                wattage: new FormControl(0), // permanent application types
                contractorName: new FormControl(null), // permanent application types
                contractorAddress: new FormControl(null), // permanent application types
                contractorTelephone: new FormControl(null, phoneNumberValidator), // permanent application types
                forSale: new FormControl(false), // permanent application types
                onShow: new FormControl(false), // permanent application types
                toLet: new FormControl(false), // permanent application types
                sold: new FormControl(false), // permanent application types
                constructionBoardSign: new FormControl(false), // permanent application types
                otherOneYear: new FormControl(null), // permanent application types
                groundSign: new FormControl(false), // permanent application types
                flag: new FormControl(false), // permanent application types
                sandwichBoard: new FormControl(false), // permanent application types
                pylon: new FormControl(false), // permanent application types
                wallSign: new FormControl(false), // permanent application types
                billboard: new FormControl(false), // permanent application types
                buildingAttachment: new FormControl(false), // permanent application types
                projectingWallSign: new FormControl(false), // permanent application types
                wallPainted: new FormControl(false), // permanent application types
                roofSign: new FormControl(false), // permanent application types
                skySign: new FormControl(false), // permanent application types
                veranda: new FormControl(false), // permanent application types
                aerialSign: new FormControl(false), // permanent application types
                windowSign: new FormControl(false), // permanent application types
                schoolSign: new FormControl(false), // permanent application types
                combinationSign: new FormControl(false), // permanent application types
                underAwningSign: new FormControl(false), // permanent application types
                flagSign: new FormControl(false), // permanent application types
                canopy: new FormControl(false), // permanent application types
                balcony: new FormControl(false), // permanent application types
                electronicSign: new FormControl(false), // permanent application types
                developmentBoard: new FormControl(false), // permanent application types
                otherFiveYear: new FormControl(null), // permanent application types
                nonIlluminatedBillboard: new FormControl(null), // permanent application types
                digitalBillboard: new FormControl(null), // permanent application types
                nonIlluminatedGantry: new FormControl(null), // permanent application types
                digitalGantry: new FormControl(null), // permanent application types
                internallyIlluminatedBillboard: new FormControl(null), // permanent application types
                internallyIlluminatedGantry: new FormControl(null), // permanent application types
                municipalConsumerAccountNumber: new FormControl(null), // permanent application types
                personResponsibleId: new FormControl(null), // permanent application types
                personResponsible: new FormControl([]),
                referenceNumber: new FormControl(null)
            }),
            advertisementsForm: new FormGroup({
                advertisements: new FormArray([], [minLengthArray(1), Validators.required]),
            }),
        });
    }
    getEntityColumn(searchColumn) {
        switch (searchColumn) {
            case SharedConstants.SEARCH_BY_DEFAULT:
                return SharedConstants.SEARCH_BY_DEFAULT;
            case SharedConstants.DASHBOARD_FILTERS.LatestApplications:
                return SharedConstants.DASHBOARD_FILTERS.LatestApplications;
            case SharedConstants.DASHBOARD_FILTERS.OverdueApplications:
                return SharedConstants.DASHBOARD_FILTERS.OverdueApplications;
            case SharedConstants.DASHBOARD_FILTERS.OpenApplications:
                return SharedConstants.DASHBOARD_FILTERS.OpenApplications;
            case SharedConstants.DASHBOARD_FILTERS.ClosedApplications:
                return SharedConstants.DASHBOARD_FILTERS.ClosedApplications;
            case SharedConstants.DASHBOARD_FILTERS.TotalApplications:
                return SharedConstants.DASHBOARD_FILTERS.TotalApplications;
            case SharedConstants.DASHBOARD_FILTERS.ApplicationStatus:
                return this.statusColumn;
            default:
                return this.searchQueryLookup.get(searchColumn);
        }
    }
    buildApplication() {
        const application = {
            referenceNumber: "",
            deleted: false,
            moduleId: Number(this.appController.selectedModuleID),
            description: this.form.get("detailsForm").get("description").value,
            type: this.form.get("detailsForm").get("type").value?.value,
            shape: "",
            wkid: 102100,
            applicantAgent: [],
            notes: [],
            eLodgementStep: 0,
            eLodgementComplete: true,
        };
        this.setApplicationDetails(application);
        this.setApplicantAndApplicantAgentDetails(application);
        this.setApplicantNotes(application);
        this.setAdvertisementsGeometry(application);
        return application;
    }
    setApplicationDetails(application) {
        application.description = this.form.get("detailsForm").get("description").value;
        application.type = this.form.get("detailsForm").get("type").value;
        application.displayStartDate = this.form.get("detailsForm").get("displayStartDate").value;
        application.displayEndDate = this.form.get("detailsForm").get("displayEndDate").value;
        application.isAdvetisingPermanentOrTemporary = this.form.get("detailsForm").get("isAdvetisingPermanentOrTemporary").value;
        application.permanentApplicationDuration = this.form.get("detailsForm").get("permanentApplicationDuration").value;
        application.displayRemovalDate = this.form.get("detailsForm").get("displayRemovalDate").value;
        application.numberOfPosters = this.form.get("detailsForm").get("numberOfPosters").value === null ? 0 : Number(this.form.get("detailsForm").get("numberOfPosters").value);
        application.nameOfBusiness = this.form.get("detailsForm").get("nameOfBusiness").value;
        application.notifySignageRemovalPeriod = this.form.get("detailsForm").get("notifySignageRemovalPeriod").value;
        application.positionOfDisplay = this.form.get("detailsForm").get("positionOfDisplay").value;
        application.dimensionsH = this.form.get("detailsForm").get("dimensionsH").value;
        application.dimensionsW = this.form.get("detailsForm").get("dimensionsW").value;
        application.dimensionsD = this.form.get("detailsForm").get("dimensionsD").value;
        application.material = this.form.get("detailsForm").get("material").value;
        application.colours = this.form.get("detailsForm").get("colours").value;
        application.frontalArea = this.form.get("detailsForm").get("frontalArea").value;
        application.totalArea = this.form.get("detailsForm").get("totalArea").value;
        application.signType = this.form.get("detailsForm").get("signType").value;
        application.weight = this.form.get("detailsForm").get("weight").value;
        application.wattage = this.form.get("detailsForm").get("wattage").value;
        application.contractorName = this.form.get("detailsForm").get("contractorName").value;
        application.contractorAddress = this.form.get("detailsForm").get("contractorAddress").value;
        application.contractorTelephone = this.form.get("detailsForm").get("contractorTelephone").value;
        application.forSale = this.form.get("detailsForm").get("forSale").value === null ? false : this.form.get("detailsForm").get("forSale").value;
        application.onShow = this.form.get("detailsForm").get("onShow").value === null ? false : this.form.get("detailsForm").get("onShow").value;
        application.toLet = this.form.get("detailsForm").get("toLet").value === null ? false : this.form.get("detailsForm").get("toLet").value;
        application.sold = this.form.get("detailsForm").get("sold").value === null ? false : this.form.get("detailsForm").get("sold").value;
        application.constructionBoardSign = this.form.get("detailsForm").get("constructionBoardSign").value === null ? false : this.form.get("detailsForm").get("constructionBoardSign").value;
        application.otherOneYear = this.form.get("detailsForm").get("otherOneYear").value;
        application.groundSign = this.form.get("detailsForm").get("groundSign").value === null ? false : this.form.get("detailsForm").get("groundSign").value;
        application.flag = this.form.get("detailsForm").get("flag").value === null ? false : this.form.get("detailsForm").get("flag").value;
        application.sandwichBoard = this.form.get("detailsForm").get("sandwichBoard").value === null ? false : this.form.get("detailsForm").get("sandwichBoard").value;
        application.pylon = this.form.get("detailsForm").get("pylon").value === null ? false : this.form.get("detailsForm").get("pylon").value;
        application.wallSign = this.form.get("detailsForm").get("wallSign").value === null ? false : this.form.get("detailsForm").get("wallSign").value;
        application.billboard = this.form.get("detailsForm").get("billboard").value === null ? false : this.form.get("detailsForm").get("billboard").value;
        application.buildingAttachment = this.form.get("detailsForm").get("buildingAttachment").value === null ? false : this.form.get("detailsForm").get("buildingAttachment").value;
        application.projectingWallSign = this.form.get("detailsForm").get("projectingWallSign").value === null ? false : this.form.get("detailsForm").get("projectingWallSign").value;
        application.wallPainted = this.form.get("detailsForm").get("wallPainted").value === null ? false : this.form.get("detailsForm").get("wallPainted").value;
        application.roofSign = this.form.get("detailsForm").get("roofSign").value === null ? false : this.form.get("detailsForm").get("roofSign").value;
        application.skySign = this.form.get("detailsForm").get("skySign").value === null ? false : this.form.get("detailsForm").get("skySign").value;
        application.veranda = this.form.get("detailsForm").get("veranda").value === null ? false : this.form.get("detailsForm").get("veranda").value;
        application.aerialSign = this.form.get("detailsForm").get("aerialSign").value === null ? false : this.form.get("detailsForm").get("aerialSign").value;
        application.windowSign = this.form.get("detailsForm").get("windowSign").value === null ? false : this.form.get("detailsForm").get("windowSign").value;
        application.schoolSign = this.form.get("detailsForm").get("schoolSign").value === null ? false : this.form.get("detailsForm").get("schoolSign").value;
        application.combinationSign = this.form.get("detailsForm").get("combinationSign").value === null ? false : this.form.get("detailsForm").get("combinationSign").value;
        application.underAwningSign = this.form.get("detailsForm").get("underAwningSign").value === null ? false : this.form.get("detailsForm").get("underAwningSign").value;
        application.flagSign = this.form.get("detailsForm").get("flagSign").value === null ? false : this.form.get("detailsForm").get("flagSign").value;
        application.canopy = this.form.get("detailsForm").get("canopy").value === null ? false : this.form.get("detailsForm").get("canopy").value;
        application.balcony = this.form.get("detailsForm").get("balcony").value === null ? false : this.form.get("detailsForm").get("balcony").value;
        application.electronicSign = this.form.get("detailsForm").get("electronicSign").value === null ? false : this.form.get("detailsForm").get("electronicSign").value;
        application.developmentBoard = this.form.get("detailsForm").get("developmentBoard").value === null ? false : this.form.get("detailsForm").get("developmentBoard").value;
        application.otherFiveYear = this.form.get("detailsForm").get("otherFiveYear").value;
        application.nonIlluminatedBillboard = this.form.get("detailsForm").get("nonIlluminatedBillboard").value;
        application.digitalBillboard = this.form.get("detailsForm").get("digitalBillboard").value;
        application.nonIlluminatedGantry = this.form.get("detailsForm").get("nonIlluminatedGantry").value;
        application.digitalGantry = this.form.get("detailsForm").get("digitalGantry").value;
        application.internallyIlluminatedBillboard = this.form.get("detailsForm").get("internallyIlluminatedBillboard").value;
        application.internallyIlluminatedGantry = this.form.get("detailsForm").get("internallyIlluminatedGantry").value;
        application.municipalConsumerAccountNumber = this.form.get("detailsForm").get("municipalConsumerAccountNumber").value;
        application.personResponsibleId = this.form.get("detailsForm").get("personResponsibleId").value;
        application.referenceNumber = this.form.get("detailsForm").get("referenceNumber").value;
        const personResponsibleValue = this.form.get("detailsForm").get("personResponsible").value;
        const personResponsible = RecipientUtils.removeRecipientProperties(personResponsibleValue);
        application.personResponsible = personResponsible ? [personResponsible] : [];
    }
    setApplicantNotes(application) {
        application.notes = this.form.get("noteForm").get("notes").value;
        const personResponsibleValue = this.form.get("detailsForm").get("personResponsible").value;
        const personResponsible = RecipientUtils.removeRecipientProperties(personResponsibleValue);
        application.personResponsible = personResponsible ? [personResponsible] : [];
    }
    setApplicantAndApplicantAgentDetails(application) {
        const applicantFormValue = this.form.get("applicantForm").get("applicantRecipient").value;
        const applicant = RecipientUtils.removeRecipientProperties(applicantFormValue);
        application.applicant = [applicant];
        const markApplicantAgentAsNotApplicable = this.form.get("applicantForm").get("markApplicantAgentAsNotApplicable").value;
        application.applicantAgentNa = !markApplicantAgentAsNotApplicable;
        const copyApplicantDetails = this.form.get("applicantForm").get("copyApplicantDetails").value;
        let applicantAgent = null;
        const applicantAgentRecipientFormControl = this.form.get("applicantForm").get("applicantAgentRecipient");
        if (copyApplicantDetails) {
            this.recipientSelectService.setRecipient(applicantFormValue, true, applicantAgentRecipientFormControl, true);
        }
        if (copyApplicantDetails === true || markApplicantAgentAsNotApplicable === true) {
            const applicantAgentFormValue = this.form.get("applicantForm").get("applicantAgentRecipient").value;
            applicantAgent = RecipientUtils.removeRecipientProperties(applicantAgentFormValue);
        }
        if (copyApplicantDetails === true || markApplicantAgentAsNotApplicable === true) {
            application.applicantAgent = [applicantAgent];
        }
    }
    setAdvertisementsGeometry(application) {
        if (application.isAdvetisingPermanentOrTemporary === "permanent") {
            this.setApplicationPointData(application);
        }
        if (application.isAdvetisingPermanentOrTemporary === "temporary") {
            this.setApplicationPolygonData(application);
        }
    }
    setApplicationPolygonData(application) {
        const points = [];
        const propertyArray = this.form.get("advertisementsForm").get("advertisements");
        propertyArray.controls.forEach((selectedPropertyControl) => {
            const centroid = selectedPropertyControl.get("centroid").value;
            points.push(`(${centroid.x} ${centroid.y})`);
        });
        const polygonShape = `POINT ${points.join(", ")}`;
        const selectedPropertyFormGroup = propertyArray.controls[0];
        const geometry = selectedPropertyFormGroup.get("geometry").value;
        const geometryJSON = WktConverterUtils.ConvertArcGISJsonToWkt(geometry);
        application.polygon = {
            id: 0,
            areaOfDisplay: selectedPropertyFormGroup.get("areaOfDisplay").value,
            streetNames: selectedPropertyFormGroup.get("streetNames").value,
            propertyDescription: selectedPropertyFormGroup.get("propertyDescription").value,
            shape: geometryJSON,
            wkid: 102100,
            deleted: false
        };
        application.shape = polygonShape;
    }
    setApplicationPointData(application) {
        const points = [];
        const propertyArray = this.form.get("advertisementsForm").get("advertisements");
        const selectedPropertyFormGroup = propertyArray.controls[0];
        const centroid = selectedPropertyFormGroup.get("centroid").value;
        const geometry = selectedPropertyFormGroup.get("geometry").value;
        const geometryJSON = WktConverterUtils.ConvertArcGISJsonToWkt(geometry);
        points.push(`(${centroid.x} ${centroid.y})`);
        const pointShape = `POINT ${points.join(", ")}`;
        application.point = {
            id: 0,
            addressStreetInformation: selectedPropertyFormGroup.get("addressStreetInformation").value,
            shape: geometryJSON,
            wkid: 102100,
            deleted: false
        };
        application.shape = pointShape;
    }
    initializeBuildingUseSearchOptions() {
        this.buildingUseSearchOptions = BpamsBuildingUseSearchOptions;
    }
    doSearchApplicationsByCreatedByUser(userId, moduleID, pageHeading) {
        // @ts-ignore
        return this.applicationSearchService
            .searchApplicationsCreatedByUser(userId, moduleID, this)
            .pipe(distinctUntilChanged(), map((applications) => this.applicationSearchService.sortApplicationList(applications, "startDate", false, "appId")), catchError((error) => {
            this.appControllerService.handleServerErrorMessage(pageHeading, error, CRUDOperation.Get);
            return throwError(error);
        }));
    }
    getApplicationTypes(jobId, moduleId) {
        const params = {
            moduleId
        };
        const url = `${ApiAdvertisingConstants.URL}/${jobId}/${ApiAdvertisingConstants.FUNCTION_APPLICATION_TYPES}`;
        return this.http.get(url, { params });
    }
    saveDraftApplication() {
    }
    getDraftApplication() {
        return null;
    }
    static ctorParameters = () => [
        { type: SaShortDatePipe },
        { type: ApplicationSearchService },
        { type: AppControllerService },
        { type: OdataQueryService },
        { type: DatePipe },
        { type: RequestStatusService },
        { type: HttpClient },
        { type: AppControllerService },
        { type: Router },
        { type: RecipientSelectService }
    ];
};
AamsStrategyService = AamsStrategyService_1 = __decorate([
    Injectable({
        providedIn: "root",
    }),
    AutoUnsub()
], AamsStrategyService);
export { AamsStrategyService };
